const BASE = process.env.REACT_APP_BACKEND_URL;

export const resolveMediaUrl = value => {
  if (!value) return "";
  if (/^(blob:|data:)/i.test(value)) return value;
  try {
    const url = new URL(value, `${BASE}/`);
    // App-owned legacy upload URLs stay portable between environments.
    if (url.pathname.startsWith("/api/uploads/") || url.pathname.startsWith("/api/attachments/")) return `${BASE}${url.pathname}${url.search}`;
    if (url.pathname.startsWith("/uploads/")) return `${BASE}/api${url.pathname}${url.search}`;
    return url.href;
  } catch { return value; }
};